import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Snowfall from './Components/Snowfall/Snowfall.js';
import Navbar from './Components/Navbar/Navbar.js';
import Carousel from './Components/Carousel/Carousel.js';
import ServicesSection from './Components/Services/ServicesSection.js';
import ServicePage from './Components/Services/ServicePage.js';
import WhyChooseUs from './Components/HowTeamCanHelp/WhyChooseUs.js';
import SoftwareIndustries from './Components/SoftwareIndustries/SoftwareIndustries.js';
import StatsSection from './Components/Stats/StatsSection.js';
import WorldClock from './Components/WorldClock/WorldClock.js';
import WebDevFAQPage from './Components/FAQ/WebDevFAQ.js';
import ContactUs from './Components/ContactUs/ContactUs.js';
import Footer from './Components/Footer/Footer.js';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop.js';
import Careers from './Components/Careers/Careers.js';
import About from './Components/About/About.js';
import ThankYou from './Components/ThankYou/ThankYou.js';

const servicePages = {
  website: {
    title: 'Website Design & Development',
    subtitle: 'Custom digital products that turn traffic into trust.',
    description:
      'We design and build modern websites that combine high-converting UX, clean engineering, and measurable business outcomes. From marketing sites to growth-focused digital experiences, our solutions are built to scale with your brand.',
    image: '/images/WebDevelopment/wordpress.png',
    highlights: [
      { icon: '🎯', title: 'Strategy-first builds', text: 'We align every page, flow, and interaction with your audience and business goals.' },
      { icon: '⚡', title: 'Performance focused', text: 'Fast, responsive experiences that reduce friction and improve conversion.' },
      { icon: '🧩', title: 'Flexible integrations', text: 'CRM, CMS, ecommerce, and third-party systems built to work together smoothly.' },
    ],
    techStack: [
      { name: 'React', img: '/images/WebDevelopment/react_logo.png' },
      { name: 'Node.js', img: '/images/WebDevelopment/terminal.PNG' },
      { name: 'WordPress', img: '/images/WebDevelopment/wordpress.png' },
      { name: 'AWS', img: '/images/WebDevelopment/AWS_logo.png' },
      { name: 'Azure', img: '/images/WebDevelopment/Azure_logo.png' },
      { name: 'HTML5', img: '/images/MobileDevelopment/Html5.PNG' },
      { name: 'Bootstrap', img: '/images/WebDevelopment/bootstrap_logo.webp' },
      { name: 'Next.js', img: '/images/WebDevelopment/NextJS_logo.PNG' },
    ],
  },
  qa: {
    title: 'Software Quality Engineering',
    subtitle: 'Reliable quality systems that keep releases safe and fast.',
    description:
      'Our quality engineering teams help product and engineering teams catch issues early, validate user journeys, and ship with measurable confidence. We blend strategy, test automation, and release readiness across web, mobile, and enterprise systems.',
    image: '/images/QE/automation-banner-element.png',
    highlights: [
      { icon: '🧪', title: 'Test strategy', text: 'We design coverage around critical user journeys and business risk.' },
      { icon: '🤖', title: 'Automation pipelines', text: 'Repeatable test systems that reduce release bottlenecks and human error.' },
      { icon: '📊', title: 'Quality reporting', text: 'Actionable insights so teams know the real product health before launch.' },
    ],
    techStack: [
      { name: 'Selenium', img: '/images/QE/Selenium.PNG' },
      { name: 'Cypress', img: '/images/QE/Cypress.PNG' },
      { name: 'Playwright', img: '/images/QE/Playwright.PNG' },
      { name: 'Postman', img: '/images/QE/Postman.PNG' },
      { name: 'Appium', img: '/images/QE/Appium.PNG' },
      { name: 'JUnit', img: '/images/QE/Java.PNG' },
      { name: 'SQL Server', img: '/images/QE/SQL_Server.PNG' },
      { name: 'Jenkins', img: '/images/QE/Jenkins.PNG' },
    ],
  },
  automation: {
    title: 'Advanced Test Automation',
    subtitle: 'Automation that accelerates delivery without sacrificing quality.',
    description:
      'We build automation frameworks that scale with your product lifecycle. From UI and API checks to end-to-end validation in CI/CD, the goal is to enable faster releases with fewer surprises.',
    image: '/images/QE/automation-banner-element.png',
    highlights: [
      { icon: '⚙️', title: 'CI/CD ready', text: 'Integrate test suites directly into release pipelines for faster feedback loops.' },
      { icon: '🔄', title: 'Reusable workflows', text: 'Frameworks built for maintainability, not one-off scripts.' },
      { icon: '📉', title: 'Reduced manual effort', text: 'Less repetitive QA work and more confidence in every build.' },
    ],
    techStack: [
      { name: 'Playwright', img: '/images/QE/Playwright.PNG' },
      { name: 'Cypress', img: '/images/QE/Cypress.PNG' },
      { name: 'Selenium', img: '/images/QE/Selenium.PNG' },
      { name: 'Appium', img: '/images/QE/Appium.PNG' },
      { name: 'Git', img: '/images/WebDevelopment/Git.PNG' },
      { name: 'Jenkins', img: '/images/QE/Jenkins.PNG' },
      { name: 'Docker', img: '/images/WebDevelopment/Docker.PNG' },
      { name: 'Swagger', img: '/images/QE/Swagger.PNG' },
    ],
  },
  ai: {
    title: 'AI Related Services',
    subtitle: 'Practical AI solutions that improve decisions, productivity, and customer experience.',
    description:
      'We help businesses adopt AI through custom automation, intelligent workflows, document processing, and AI-powered customer experiences. From strategy to deployment, we design solutions that align with real operational goals and measurable value.',
    image: '/images/QE/automation-banner-element.png',
    highlights: [
      { icon: '🧠', title: 'AI strategy', text: 'Identify the best use cases and ROI opportunities for AI in your business.' },
      { icon: '⚡', title: 'Workflow automation', text: 'Turn repetitive work into smart, scalable systems that save time and reduce errors.' },
      { icon: '📊', title: 'Predictive insights', text: 'Leverage data to uncover trends, automate decisions, and improve outcomes.' },
    ],
    techStack: [
      { name: 'Claude Code', img: '/images/WebDevelopment/terminal.PNG' },
      { name: 'Cursor', img: '/images/WebDevelopment/terminal.PNG' },
      { name: 'GitHub Copilot', img: '/images/WebDevelopment/Git.PNG' },
      { name: 'Azure OpenAI', img: '/images/WebDevelopment/Azure_logo.png' },
      { name: 'OpenAI API', img: '/images/WebDevelopment/Python.PNG' },
      { name: 'Prompt Engineering', img: '/images/WebDevelopment/terminal.PNG' },
      { name: 'RAG Pipelines', img: '/images/WebDevelopment/Docker.PNG' },
      { name: 'AI Workflows', img: '/images/WebDevelopment/AWS_logo.png' },
    ],
  },
  marketing: {
    title: 'Digital Marketing and SEO',
    subtitle: 'Search visibility, stronger demand generation, and measurable growth.',
    description:
      'From SEO and paid media to content strategy and social growth, we help businesses reach the right people at the right time. Our marketing work blends performance measurement with brand-building that drives long-term value.',
    image: '/images/DigitalMarketing/digitalMarketing.PNG',
    highlights: [
      { icon: '📈', title: 'Search visibility', text: 'Improve rankings and discoverability across the channels that matter.' },
      { icon: '🎯', title: 'Audience targeting', text: 'Reach high-intent users with data-backed campaigns and positioning.' },
      { icon: '📊', title: 'Analytics clarity', text: 'Track what drives leads, sales, and customer retention over time.' },
    ],
    techStack: [
      { name: 'Google Ads', img: '/images/DigitalMarketing/googleads.svg' },
      { name: 'SEO', img: '/images/DigitalMarketing/seo.svg' },
      { name: 'Analytics', img: '/images/WebDevelopment/AWS_logo.png' },
      { name: 'Meta Ads', img: '/images/DigitalMarketing/marketing.svg' },
      { name: 'Reporting', img: '/images/WebDevelopment/terminal.PNG' },
      { name: 'Content', img: '/images/DigitalMarketing/audit.png' },
      { name: 'Social', img: '/images/DigitalMarketing/socialMedia.jpg' },
      { name: 'Strategy', img: '/images/DigitalMarketing/campaign-strategy.png' },
    ],
  },
  mobile: {
    title: 'Mobile App Development',
    subtitle: 'High-performance apps for the experiences your users expect.',
    description:
      'We build scalable mobile apps for iOS and Android using a product-minded, user-first process. Whether it is a startup MVP or an enterprise-grade application, we craft solutions that are smooth, secure, and easy to maintain.',
    image: '/images/MobileDevelopment/Banner_Mobile.jpg',
    highlights: [
      { icon: '📱', title: 'Cross-platform logic', text: 'Deliver consistent experiences across mobile ecosystems.' },
      { icon: '🧠', title: 'User experience', text: 'Polished interfaces that feel intuitive and conversion-friendly.' },
      { icon: '🔐', title: 'Operational reliability', text: 'Built with secure data flows and maintainable architecture.' },
    ],
    techStack: [
      { name: 'Android', img: '/images/MobileDevelopment/android.PNG' },
      { name: 'iOS', img: '/images/QE/iOS.PNG' },
      { name: 'React Native', img: '/images/WebDevelopment/react_native.PNG' },
      { name: 'Flutter', img: '/images/WebDevelopment/Flutter.PNG' },
      { name: 'Swift', img: '/images/WebDevelopment/Swift.PNG' },
      { name: 'Dart', img: '/images/WebDevelopment/Dart_Flutter.PNG' },
      { name: 'Android Studio', img: '/images/WebDevelopment/AndroidStudio.png' },
      { name: 'HTML5', img: '/images/MobileDevelopment/Html5.PNG' },
    ],
  },
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className='App'>
        <Snowfall />
        <Navbar />
        <div className='page-content'>
          <Routes>
            <Route
              path='/'
              element={
                <>
                  <Carousel />
                  <ServicesSection />
                  <WhyChooseUs />
                  <SoftwareIndustries />
                  <StatsSection />
                  <WorldClock />
                  <WebDevFAQPage />
                  <ContactUs />
                  <Footer />
                </>
              }
            />
            <Route
              path='/careers'
              element={
                <>
                  <Careers />
                  <Footer />
                </>
              }
            />
            <Route
              path='/about'
              element={
                <>
                  <About />
                  <Footer />
                </>
              }
            />
            <Route
              path='/website-design-development'
              element={<ServicePage {...servicePages.website} />}
            />
            <Route
              path='/software-quality-engineering'
              element={<ServicePage {...servicePages.qa} />}
            />
            <Route
              path='/advanced-test-automation'
              element={<ServicePage {...servicePages.automation} />}
            />
            <Route
              path='/ai-related-services'
              element={<ServicePage {...servicePages.ai} />}
            />
            <Route
              path='/digital-marketing-seo'
              element={<ServicePage {...servicePages.marketing} />}
            />
            <Route
              path='/mobile-app-development'
              element={<ServicePage {...servicePages.mobile} />}
            />
            <Route path='/thank-you' element={<ThankYou />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
